import { gate } from 'hub-http/gates';
export const getHasBusinessUnitsRebrand = gates => gates.includes(gate('MultiAccount:BusinessUnitsRebrand'));
export const getHasBusinessUnitUsersAccess = gates => gates.includes('business-units:business-unit-users');
export const getHasBusinessUnitsViewAllScope = userScopes => userScopes.includes('business-units-view-all');
export const getHasBusinessUnitsWriteScope = userScopes => userScopes.includes('business-units-write');